import { useFetchCategories } from "@sushicorp/services";
import { sanitizeQueryParams, toSentenceCaseUtility } from "@sushicorp/utils";
import { Button } from "artisn-ui-react";
import { useRouter } from "next/router";
import React from "react";
import { Link } from "react-scroll";

import Styles from "./CategoryList.styles";
import { CategoryListProps as Props } from "./CategoryList.types";
import CommonPlaceholder from "components/global/CommonPlaceholder/CommonPlaceholder";
import { notify } from "utils/common.utils";

const CategoryList: React.FC<Props> = props => {
  const { className, onClickCategoryItem, withScrollTo } = props;
  const { activeCategoryId } = props;
  const categoriesResponse = useFetchCategories(notify);
  const { query } = useRouter();
  const { categoryId: categoryIdParam } = sanitizeQueryParams(query);
  const { data: categories, isLoading, isError } = categoriesResponse;
  const placeholdersNode = (
    <>
      <CommonPlaceholder />
      <CommonPlaceholder />
      <CommonPlaceholder />
      <CommonPlaceholder />
      <CommonPlaceholder />
      <CommonPlaceholder />
      <CommonPlaceholder />
      <CommonPlaceholder />
      <CommonPlaceholder />
    </>
  );

  /**
   * Render category list component-
   *
   * @since 1.0.0
   * @returns Category list component.
   */
  const renderCategoryList = () => {
    return categories
      ?.filter(category => category.displayInMenu)
      .map((category, index) => {
        const { categoryId, name } = category;
        const enhancedName = toSentenceCaseUtility(name);

        return withScrollTo ? (
          <Link
            key={categoryId}
            title={enhancedName}
            className="CategoryList__item"
            activeClass="CategoryList__item--active"
            to={`${categoryId}`}
            spy
            smooth
            offset={-136}
          >
            <div onClick={() => onClickCategoryItem?.(category)}>
              {enhancedName}
            </div>
          </Link>
        ) : (
          <Button
            key={categoryId}
            className={`CategoryList__item ${
              activeCategoryId === categoryId
                ? `CategoryList__item--active`
                : ""
            } ${
              categoryIdParam === categoryId.toString()
                ? "CategoryList__item--active"
                : ""
            }`}
            type="LINK"
            onClick={() => onClickCategoryItem?.(category)}
          >
            {name}
          </Button>
        );
      });
  };

  if (isError) return null;

  return (
    <Styles className={`CategoryList ${className}`}>
      <p className="CategoryList__title">Categorías</p>
      {isLoading ? placeholdersNode : renderCategoryList()}
    </Styles>
  );
};

CategoryList.defaultProps = {
  className: ""
};

export default CategoryList;
